const AUTH_CHANNELS = {
  'facebookProfile': true,
  'facebookPage': true,
  'googlePlusProfile': true,
  'shopifyShop': true,
  'instagramProfile': true,
  'twitterProfile': true,
  'pinterestProfile': true,
  'pinterestBoard': true
}

const MUTATION_CHANNELS = {
  'informacijaShop': true,
  'sqwizPage': true,
  'shopamineShop': true,
  'wooCommerceShop': true,
  'elasticEmailAccount': true,
  'wordpressWebsite': true
}

export default {
  computed: {
    /**
     * Determines what connector should be used for the given chanel type
     * @requires {activeConnectorType} Parent's property
     * @returns {String} Connector type
     */
    getRequestedConnector () {
      if (AUTH_CHANNELS[this.activeConnectorType]) {
        return 'auth-connector'
      } else if (MUTATION_CHANNELS[this.activeConnectorType]) {
        switch (this.activeConnectorType) {
          case "wordpressWebsite":
            return "wordpress-website"
        }

        return 'mutation-connector'
      } else {
        return 'not-implemented'
      }
    },

    /**
     * Tells channel's type - used for GQL mutation
     * @requires {getConnectorsChannelType} Mixin's property
     * @returns {String} Channel's type
     */
    getConnectorsType () {
      return this.getConnectorsChannelType.channelType
    },

    /**
     * Tells channel's label - used for mutation popup
     * @requires {getConnectorsChannelType} Mixin's property
     * @returns {String} Channel's label
     */
    getConnectorsLabel () {
      return this.getConnectorsChannelType.connectorLabel
    },

    /**
     * Tells what fields the connector should have
     * @requires {getConnectorsChannelType} Mixin's property
     * @returns {String} Mutation's fields
     */
    getConnectorsFields () {
      return this.getConnectorsChannelType.fields || []
    },

    /**
     * Gives channel's params
     * @requires {activeConnectorType} Parent's property
     * @returns {Object} An object of channel properties
     */
    getConnectorsChannelType () {
      switch (this.activeConnectorType) {
        case 'facebookProfile':
          return {
            channelType: 'facebook',
            connectorLabel: 'Facebook Profil'
          }

        case 'facebookPage':
          return {
            channelType: 'facebook',
            connectorLabel: 'Facebook Stran'
          }

        case 'googlePlusProfile':
          return {
            channelType: 'gplus',
            connectorLabel: 'Google'
          }

        case 'instagramProfile':
          return {
            channelType: 'instagram',
            connectorLabel: 'Instagram'
          }

        case 'twitterProfile':
          return {
            channelType: 'twitter',
            connectorLabel: 'Twitter'
          }

        case 'pinterestProfile':
          return {
            channelType: 'pinterest',
            connectorLabel: 'Pinterest'
          }

        case 'pinterestBoard':
          return {
            channelType: 'pinterest',
            connectorLabel: 'Pinterest'
          }

        case 'informacijaShop':
          return {
            channelType: 'informacijaShop',
            connectorLabel: 'Informacija',
            fields: [
              {
                name: 'key',
                tooltipLabel: 'ChannelConnctor.informacijaShop.key.tooltipLabel',
                label: 'ChannelConnctor.informacijaShop.key.label',
                placeholder: 'ChannelConnctor.informacijaShop.key.placeholder'
              }
            ]
          }

        case 'sqwizPage':
          return {
            channelType: 'sqwizPage',
            connectorLabel: 'Sqwiz',
            fields: [
              {
                name: 'key',
                tooltipLabel: 'ChannelConnctor.sqwizPage.key.tooltipLabel',
                label: 'ChannelConnctor.sqwizPage.key.label',
                placeholder: 'ChannelConnctor.sqwizPage.key.placeholder'
              }
            ]
          }

        case 'shopamineShop':
          return {
            channelType: 'shopamineShop',
            connectorLabel: 'Shopamine',
            fields: [
              {
                name: 'url',
                tooltipLabel: 'ChannelConnctor.shopamineShop.url.tooltipLabel',
                label: 'ChannelConnctor.shopamineShop.url.label',
                placeholder: 'ChannelConnctor.shopamineShop.url.placeholder'
              },
              {
                name: 'key',
                tooltipLabel: 'ChannelConnctor.shopamineShop.key.tooltipLabel',
                label: 'ChannelConnctor.shopamineShop.key.label',
                placeholder: 'ChannelConnctor.shopamineShop.key.placeholder'
              }
            ]
          }

        case 'shopifyShop':
          return {
            channelType: 'shopify',
            connectorLabel: 'Shopify',
            fields: [
              {
                name: 'shop',
                tooltipLabel: 'ChannelConnctor.shopifyShop.shop.tooltipLabel',
                label: 'ChannelConnctor.shopifyShop.shop.label',
                placeholder: 'ChannelConnctor.shopifyShop.shop.placeholder'
              }
            ]
          }

        case 'wooCommerceShop':
          return {
            channelType: 'wooCommerceShop',
            connectorLabel: 'Woocommerce',
            fields: [
              {
                name: 'url',
                tooltipLabel: 'ChannelConnctor.wooCommerceShop.url.tooltipLabel',
                label: 'ChannelConnctor.wooCommerceShop.url.label',
                placeholder: 'ChannelConnctor.wooCommerceShop.url.placeholder'
              },
              {
                name: 'key',
                tooltipLabel: 'ChannelConnctor.wooCommerceShop.key.tooltipLabel',
                label: 'ChannelConnctor.wooCommerceShop.key.label',
                placeholder: 'ChannelConnctor.wooCommerceShop.key.placeholder'
              },

              {
                name: 'secret',
                tooltipLabel: 'ChannelConnctor.wooCommerceShop.secret.tooltipLabel',
                label: 'ChannelConnctor.wooCommerceShop.secret.label',
                placeholder: 'ChannelConnctor.wooCommerceShop.secret.placeholder'
              }
            ]
          }

        case 'elasticEmailAccount':
          return {
            channelType: 'elasticEmailAccount',
            connectorLabel: 'Elastic Email',
            fields: [
              {
                name: 'key',
                tooltipLabel: 'key',
                label: 'Your api key',
                placeholder: 'Api key'
              }
            ]
          }

        case 'wordpressWebsite':
          return {
            channelType: 'wordpressWebsite',
            connectorLabel: 'Wordpress',
            fields: [
              {
                name: 'url',
                tooltipLabel: 'ChannelConnctor.wordpressWebsite.url.tooltipLabel',
                label: 'ChannelConnctor.wordpressWebsite.url.label',
                placeholder: 'ChannelConnctor.wordpressWebsite.url.placeholder'
              },
              {
                name: 'key',
                tooltipLabel: 'ChannelConnctor.wordpressWebsite.key.tooltipLabel',
                label: 'ChannelConnctor.wordpressWebsite.key.label',
                placeholder: 'ChannelConnctor.wordpressWebsite.key.placeholder'
              },

              {
                name: 'secret',
                tooltipLabel: 'ChannelConnctor.wordpressWebsite.secret.tooltipLabel',
                label: 'ChannelConnctor.wordpressWebsite.secret.label',
                placeholder: 'ChannelConnctor.wordpressWebsite.secret.placeholder'
              }
            ]
          }

        default:
          return {
            channelType: 'not-implemented',
            connectorLabel: 'ChannelConnctor.notImplemented.connectorLabel'
          }
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/standard/connectors/connectors.js